/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React base styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Vision UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import boxShadow from "assets/theme/functions/boxShadow";

const { dark, white } = colors;
const { borderWidth, borderColor } = borders;

export default {
  styleOverrides: {
    root: {
      background: "#d8e6f7",
      fill: "#d8e6f7",
      stroke: "#d8e6f7",
      strokeWidth: pxToRem(10),
      width: pxToRem(13),
      height: pxToRem(13),
      border: `${borderWidth[2]} solid #c0d4ef`,
      borderRadius: "50%",
      zIndex: 99,
      transition: "all 200ms linear",

      "&.Mui-active": {
        background: "#0057d8",
        fill: "#0057d8",
        stroke: "#0057d8",
        borderColor: "#0057d8",
        boxShadow: boxShadow([0, 0], [0, 4], "#0057d8", 0.4),
      },

      "&.Mui-completed": {
        background: "#0057d8",
        fill: "#0057d8",
        stroke: "#0057d8",
        borderColor: "#0057d8",
        boxShadow: boxShadow([0, 0], [0, 4], "#0057d8", 0.3),
      },
    },
  },
};

